import {ShapeComponent, shapeComponent} from "set-state-compare/build/shape-component"
import memo from "set-state-compare/build/memo"
import PropTypes from "prop-types"
import propTypesExact from "prop-types-exact"
import React from "react"
import {Text} from "shared/base"
import {View} from "react-native"
/**
 * @typedef {object} ContentsErrorsProps
 * @property {unknown} errors
 */

/** @typedef {object} ContentsErrorsState */

/**
 * @extends {ShapeComponent<ContentsErrorsProps, ContentsErrorsState>}
 */
class ContentsErrors extends ShapeComponent {
  static propTypes = propTypesExact({
    errors: PropTypes.array.isRequired
  })

  render() {
    const {errors} = this.p

    return (
      <View dataSet={{component: "contents/errors"}}>
        {errors.map((error, errorIndex) =>
          <Text key={`${errorIndex}-${error.message}`} style={{color: "red"}}>
            {error.message}
          </Text>
        )}
      </View>
    )
  }
}

export default memo(shapeComponent(ContentsErrors))
